import Alert from 'src/components/dialogs/Alert';
import dialogController from 'src/controller/dialogController';
import Modal from 'src/components/Modal';
import { Alert as IAlert } from 'src/interfaces/dialog';

const showAlert = (alert: IAlert): void => {
  const id = `alert-${Date.now()}`;
  const onClose = () => dialogController.popById(id);
  const modal = (
    <Modal onClose={() => dialogController.popById(id)}>
      <Alert {...alert} onClose={onClose} />
    </Modal>
  );
  dialogController.addDialog({ id: id, component: modal });
};

export default showAlert;
